
(function($) {

    let $bookCart;
    let $bookRightCol;

    let metrics = {};

    let positionFixed = 0;

    function updateStickyPosition() {

        if (!$bookCart || !$bookCart.length) {
            return;
        }

        const shopHeaderHeight = $(".shop-header").outerHeight();

        positionFixed = $bookCart.offset().top - shopHeaderHeight;
    }

    function updateMetrics() {
        metrics.shopHeaderHeight = $(".shop-header").outerHeight();
        metrics.pageTopHeight = $(".pagetop").outerHeight();
        metrics.breadcrumbHeight = $(".breadcrumb").outerHeight();

        metrics.containerHeight = $(".book-detail__right").outerHeight();

        metrics.fullHeight =
            metrics.containerHeight +
            metrics.shopHeaderHeight +
            metrics.pageTopHeight +
            metrics.breadcrumbHeight;

        metrics.bookCartHeight = $bookCart.outerHeight();
    }

    // Page détail publication - 2ème image
    const container = document.querySelector('.book-detail__image-mobile');
    const containerRight = document.querySelector('.book-detail__image');

    if (container && containerRight) {

        function setContainerHeight() {
            const images = container.querySelectorAll('.book-image');

            containerRight.style.height = '';

            if (images.length > 1) {
                containerRight.style.height = `${container.offsetHeight}px`;
            }
        }

        setContainerHeight();

        new ResizeObserver(() => {
            setContainerHeight();
        }).observe(container);

        window.addEventListener('resize', setContainerHeight);
    }

    // Page détail publication - Encart panier / partage
    function initStickyCart() {
        $bookCart = $(".book-detail__cart");
        $bookRightCol = $bookCart.parents(".book-detail__right");

        if (!$bookCart.length || !$bookRightCol.length) return;

        if ($(window).width() <= 1199) {
            // Reset si on repasse en mobile
            $bookCart.removeClass("position-fixed position-fixed-footer");
            $bookRightCol.css("position", "static");
            return;
        }

        updateStickyPosition();
        updateMetrics(); // <-- initialisation

        let is_sticky = false;

        $(document).off("scroll.stickyCart").on("scroll.stickyCart", function () {
            if ($(window).width() <= 1199) return;

            updateMetrics();

            if (window.scrollY + metrics.bookCartHeight - metrics.fullHeight > 0) {
                $bookCart.removeClass("is-fixed");
                $bookCart.addClass("position-fixed-footer");
                $bookRightCol.css("position", "static");
                is_sticky = false;
            }

            if (!is_sticky && positionFixed <= window.scrollY && window.scrollY + metrics.bookCartHeight - metrics.fullHeight < 0) {
                $bookCart.addClass("position-fixed");
                $bookCart.removeClass("position-fixed-footer");
                $bookRightCol.css("position", "relative");
                is_sticky = true;
            } else if (is_sticky && positionFixed > window.scrollY) {
                $bookCart.removeClass("position-fixed");
                is_sticky = false;
            }
        });
    }

    $(document).ready(function () {
        initStickyCart();
    });

    $(window).on("resize", function () {
        initStickyCart();
        updateStickyPosition();
        updateMetrics();
    });

    $(function () {
        // Page panier - Récap panier
        let $summary = $("#checkout-step-summary");
        let $cartRightCol = $(".tx-cart__container");
        let windowWidth = $(window).width();

        if ($summary.length && $cartRightCol.length) {
            if( windowWidth > 1399 ) {

                let is_sticky = false;
                let position_fixed = $summary.offset().top;
                let container_height = $(".tx-cart__container").outerHeight();
                let page_top_height = $(".pagetop").outerHeight();
                let breadcrumb_height = $(".breadcrumb").outerHeight();
                let container_highlight_height = $(".container--highlight").outerHeight();
                let full_height = container_height + page_top_height + breadcrumb_height + container_highlight_height;
                let resume_height = $summary.outerHeight();
                // let frame_height = $cartRightCol.outerHeight();

                $(document).scroll(function () {
                    if (window.scrollY + resume_height - full_height > 0) {
                        $summary.removeClass("is-fixed");
                        $summary.addClass("position-fixed-footer");
                        // $cartRightCol.css("position", "static");
                        // $(".entry-content").css("position", "relative");
                        is_sticky = false;
                    }
                    if (!is_sticky && position_fixed <= window.scrollY && window.scrollY + resume_height - full_height < 0) {
                        $summary.addClass("position-fixed");
                        $summary.removeClass("position-fixed-footer");
                        $cartRightCol.css("position", "relative");
                        // $cartRightCol.css("height", frame_height + "px");
                        //$(".entry-content").css("position", "static");
                        is_sticky = true;
                    } else if (is_sticky && position_fixed > window.scrollY) {
                        $summary.removeClass("position-fixed");
                        is_sticky = false;
                    }
                });
            }
        }

        // Page détail publication - shop header fixé au scroll
        let $shop_header = $(".shop-header");
        let $txCart = $shop_header.parents(".tx-tccart");

        if ($shop_header.length && $txCart.length) {

            if( $(window).width() > 1023 ) {

                let is_sticky = false;
                let shop_header_height = $shop_header.outerHeight() + 25;
                let page_top_height = $(".pagetop").outerHeight();
                let breadcrumb_height = $(".breadcrumb").outerHeight();
                // let sticky_offset = page_top_height + breadcrumb_height;
                let sticky_offset = $shop_header.offset().top;

                $(document).scroll(function () {

                    let last_scroll_position = window.pageYOffset;

                    if(!is_sticky && last_scroll_position >= sticky_offset) {
                        $shop_header.addClass('shop-header--sticky');
                        is_sticky = true;
                        $txCart.css("padding-top", shop_header_height + "px");
                    }
                    else if(is_sticky && last_scroll_position < sticky_offset) {
                        $shop_header.removeClass('shop-header--sticky');
                        is_sticky = false;
                        $txCart.css("padding-top", "0")
                    }

                });
            }
        }

        let productTable = $(".checkout-product-table");

        if (productTable.length) {
            let btnMinus = $(".qty-minus");
            let btnPlus = $(".qty-plus");

            btnMinus.each( function() {
                $(this).click(function() {
                    let qtyInput = btnMinus.next(".qty");
                    qtyInput.style("outline", "1px dotted green");
                    // let currentValue = parseInt(qtyInput.val(), 10) || 0;
                    // qtyInput.val(currentValue - 1);
                });
            });


            btnPlus.each( function() {
                $(this).click(function() {
                    let qtyInput = btnPlus.prev(".qty");
                    // let currentValue = parseInt(qtyInput.val(), 10) || 0;
                    // qtyInput.val(currentValue + 1);
                });
            });
        }

        // Page présentation des publications

        /* const header = document.querySelector(".layout-portail .shop-header");
        if (!header) return;

        const placeholder = document.createElement("div");
        placeholder.style.height = header.offsetHeight + "px";
        placeholder.style.display = "none";

        header.parentNode.insertBefore(placeholder, header);

        const headerOffsetTop = header.offsetTop;

        window.addEventListener("scroll", function () {
            if (window.scrollY >= headerOffsetTop) {
                header.classList.add("is-fixed");
                placeholder.style.display = "block";
            } else {
                header.classList.remove("is-fixed");
                placeholder.style.display = "none";
            }
        }); */

    });

})(jQuery);
